module.exports = __webpack_public_path__ + "assets_app/img/audio_back.bd9a6fb5.svg";